import { MotionConfig, useReducedMotion } from 'framer-motion'

/**
 * Simplified Studio layout shell. Per Decisions 7 & 8 the marketing surface
 * uses a single shared Radiant Navbar + Footer, so this RootLayout only
 * provides the marketing typeface scope (`.marketing-root` → Geist) and a
 * reduced-motion-aware MotionConfig. Pages compose Navbar + content + Footer
 * inside it.
 */
export function RootLayout({ children }: { children: React.ReactNode }) {
  const shouldReduceMotion = useReducedMotion()

  return (
    <MotionConfig transition={shouldReduceMotion ? { duration: 0 } : undefined}>
      <div className="marketing-root flex min-h-screen flex-col bg-white text-neutral-950">
        {children}
      </div>
    </MotionConfig>
  )
}
